import { map, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { each } from 'lodash';

import { settings } from '../../app.settings';
import { BaseService } from '~common/app/shared/services/base.service';
import { Brand, toApi, fromApi } from '../../shared/models/brand';
import { Store } from '../../shared/models/store';
import { NaiveParameterCodec } from '~common/app/shared/utils/encoding';

const API_PATH = settings.api.url + '/programs/me/brands';
const API_PATH_STORES = settings.api.url + '/stores';
const API_PATH_UNIVERSES = settings.api.url + '/universes';

@Injectable()
export class BrandService extends BaseService {
  constructor(
    private http: HttpClient
  ) {
    super();
  }

  fetch(params = {}): Observable<any> {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    each(params, (value: any, key) => {
      if (key === 'filters') {
        if (value.term) {
          apiParams = apiParams.append('keyword', value.term);
        }
      } else if (value || value === 0) {
        apiParams = apiParams.append(key, value);
      }
    });

    return this.http.get(API_PATH, {
      params: apiParams
    }).pipe(map((response) => {
      return this.hydrate(Brand, response);
    }));
  }

  get(id): Observable<any> {
    return this.http.get(API_PATH + '/' + id).pipe(map(response => {
      response = fromApi(response);

      return this.hydrate(Brand, response);
    }));
  }

  create(data): Observable<any> {
    return this.http.post(API_PATH, toApi(data)).pipe(map(response => {
      response = fromApi(response);

      return this.hydrate(Brand, response);
    }));
  }

  update(id, data): Observable<any> {
    return this.http.put(API_PATH + '/' + id, toApi(data)).pipe(map(response => {
      response = fromApi(response);

      return this.hydrate(Brand, response);
    }));
  }

  delete(id): Observable<any> {
    return this.http.delete(API_PATH + '/' + id);
  }

  save(data) {
    if (data.id) {
      return this.update(data.id, data);
    } else {
      return this.create(data);
    }
  }

  fetchUniverses() {
    return this.http.get(API_PATH_UNIVERSES);
  }

  fetchStores(id, params = {}): Observable<any> {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    apiParams = apiParams.append('brand', id);

    each(params, (value: any, key) => {
      if (key === 'filters') {
        if (value.term) {
          apiParams = apiParams.append('name', value.term);
        }
      } else if (value || value === 0) {
        apiParams = apiParams.append(key, value);
      }
    });

    return this.http.get(API_PATH_STORES, {
      params: apiParams
    }).pipe(map((response) => {
      return this.hydrate(Store, response);
    }));
  }

  autocomplete(query: string, limit = 100) {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });
    apiParams = apiParams.append('query', query);
    apiParams = apiParams.append('limit', '' + limit);

    return this.http.get(API_PATH + '/search', {
      params: apiParams
    });
  }
}
